import { useQuery } from "@tanstack/react-query"
import { apiClientV2 } from "../../../services/api/apiClient"
import type { CustomerDashboardStats } from "./types"

const zero = { count: 0, total: 0 }

// No regulation rows until the dashboard loads: the rows are the org's own set
// (TUR-1734), so a fallback cannot guess them.
const EMPTY_FRAMEWORKS: CustomerDashboardStats["frameworks"] = []

export const EMPTY_CUSTOMER_DASHBOARD_STATS: CustomerDashboardStats = {
  products: { ...zero },
  customers: { ...zero },
  statusBuckets: {
    answering: { ...zero },
    waitingOnYou: { ...zero },
    gaps: { ...zero },
    overdue: { ...zero },
  },
  frameworks: EMPTY_FRAMEWORKS,
  conformity: { draft: 0, flaggedSvhc: 0, approved: 0, issuedQuarter: 0 },
  gaps: { blockedRequests: 0, openQuestions: 0, stagedInquiries: 0 },
  waitingTop: [],
  openTop: [],
  gapsTop: [],
}

async function getCustomerDashboard(): Promise<CustomerDashboardStats> {
  // No .catch() here — a network/server error must reject so React Query
  // surfaces isError and retries, instead of silently rendering an empty
  // org (see F9). The caller (DashboardPage) supplies
  // EMPTY_CUSTOMER_DASHBOARD_STATS as display fallback while showing an
  // error banner.
  return apiClientV2
    .get("/material-compliance/customer-studio/dashboard")
    .then((r) => ({
      ...EMPTY_CUSTOMER_DASHBOARD_STATS,
      ...(r.data as Partial<CustomerDashboardStats>),
    }))
}

export function useCustomerDashboard() {
  return useQuery({
    queryKey: ["mc", "customer-dashboard"],
    queryFn: getCustomerDashboard,
  })
}
